// extracted by mini-css-extract-plugin
export default {"wrapper":"Raa","container":"Saa","box":"Taa","title":"Uaa","rdwrap":"Vaa","rditem":"Waa","rdimage":"Xaa","name":"Yaa","heading":"Zaa","text":"aba","guarantee":"bba","chatbox":"cba"};
    if(module.hot) {
      // 1715091685913
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  